import AppButton from '../../../../components/ui/AppButton';

const TransferButton = ({ onClick }) => {
  return (
    <AppButton variant="dangerStrong" size="small" onClick={onClick}>
      ย้ายบริษัท
    </AppButton>
  );
};
export default TransferButton;
